import { gridSizeMdLg12 } from "@/shared";
import { Box, Grid, lighten, LinearProgress, styled, Typography } from "@mui/material";
import { useEffect, useState } from "react";

type Props = {
    color?: 'primary' | 'secondary';
    hex?: string;

    form?: any;
    fieldsToCheck?: string[]
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 20,
    width: '100%',
    borderRadius: '10px',
    backgroundColor:
      theme.palette.grey[theme.palette.mode === 'light' ? 400 : 800],
}));

const SummaryPanelComponentActivaciones = ({
    color,
    hex,
    form,
    fieldsToCheck
}: Props) => {

    const [value, setValue] = useState(0);
    let CHANGES_IN_FIELDS = fieldsToCheck?.map(field => form?.watch()?.[field])

    let internalColor: string;

    

    let completedFields = fieldsToCheck?.filter(field => !!form?.getValues()?.[field]).length || 0
  
    let totalFields = fieldsToCheck?.length || 0
      
    // let value: number | string = ((completedFields||1) / (totalFields||1)) * 100;
    // setValue(((completedFields||1) / (totalFields||1)) * 100);
    // if (isNaN(value)) setValue(0);
    // setValue(Number(Math.round(value).toFixed(2)));
  
    if (hex && /^#[0-9A-F]{6}$/i.test(hex)) {
      internalColor = hex;
    } else {
      internalColor = '#3f51b5';
    }
  
    if (+value < 0 || +value > 100) {
      throw new Error(
        'Invalid value prop -- please use a number between 0 and 100.'
      );
    }

    useEffect(()=>{
      completedFields = fieldsToCheck?.filter(field => !!form?.getValues()?.[field]).length || 0
      totalFields = fieldsToCheck?.length || 0
      const newValue = ((completedFields||0) / (totalFields||1)) * 100;
      if (isNaN(newValue)) setValue(0);
      setValue(Number(Math.round(newValue).toFixed(2)));
      form.setValue("campos_completados",completedFields===totalFields)
      console.log({changes:CHANGES_IN_FIELDS, completedFields, totalFields})
    },CHANGES_IN_FIELDS)
  
    return (
      <>
        {/* <Button
          variant="contained"
          color="primary"
          onClick={() => setValue(value + 10)}
        >
          Guardar
        </Button> */}
        {
          completedFields !== totalFields?
          <>
          <Typography variant="h6" color="orange">Debe completar los siguientes campos:</Typography>
          <Grid {...gridSizeMdLg12} container item px={4} py={2}>
            {
              <ul>
              {fieldsToCheck?.map((field,index)=>{
                if(!!form.getValues(field)){
                  return null
                }else{
                  return <li key={field+index}>{field?.replaceAll("_"," ")?.toUpperCase()}</li>
                }
              })}
              </ul>
            }
          </Grid>
          </>
          :null
        }
        <Box position="relative" display="inline-flex" width={"100%"} sx={{px:2}} >
          <BorderLinearProgress
            color={hex ? undefined : color}
            variant="determinate"
            value={+value}
            sx={{
              backgroundColor: hex ? lighten(internalColor, 0.5) : undefined,
              '& .MuiLinearProgress-bar': {
                borderRadius: 20,
                backgroundColor: hex ? internalColor : undefined,
              },
            }}
          />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography style={{ color: 'white', fontWeight: 'bold' }} variant="body2">{`${value}% (${
              completedFields || 0
            } de ${totalFields})`}</Typography>
          </Box>
        </Box>
      </>
    )
}

export default SummaryPanelComponentActivaciones